import { render, staticRenderFns } from "./novaPropostaMA.vue?vue&type=template&id=3311708f&scoped=true"
import script from "./novaPropostaMA.vue?vue&type=script&lang=js"
export * from "./novaPropostaMA.vue?vue&type=script&lang=js"
import style0 from "./novaPropostaMA.vue?vue&type=style&index=0&id=3311708f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3311708f",
  null
  
)

export default component.exports